module.exports = __webpack_public_path__ + "static/media/info-notification-icon.b028ac45.svg";